/*
 * Purpose : Declaration Form Home Page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { Component } from 'react'
import { NavLink } from "react-router-dom"
import ReactTable from 'react-table';
//import 'react-table/react-table.css';
import './Transactions.css';
import { Button, Alert } from 'reactstrap'
import { MdEdit, MdVisibility, MdDelete } from 'react-icons/md';
import axios from 'axios';

import { errorConstants, homeColumns, homeColumnHeaders } from '../../config/constants';
import Aux from '../../hoc/Auxilliary/Auxilliary';
import { PostFormService } from './../../services/PostFormDataService';
import AppContext from '../../context/app-context';
import LoadingModal from '../../components/UI/modals/loadingModal';
import { Col, Row } from "reactstrap";
//amplify conf
import { API, graphqlOperation } from 'aws-amplify';
import BackButton from "../UI/Buttons/BackButton/BackButton"
import { listExcesstransactionss } from '../../graphql/queries';

const postform = new PostFormService();

export default class Transactions extends Component {
    constructor() {
        super()
        this.state = {
            items: [],
            loading: false,
            deleteRequested: false,
            results: []
        }
        this.handleEdit = this.handleEdit.bind(this)
        this.handleView = this.handleView.bind(this)
    }
    static contextType = AppContext;
    async componentDidMount() {
        //console.log(" transactions context user=>",this.context.user);
        this.fetchTransactions();
    }
    render() {
        if (this.state.error) {
            return (
                <Alert color="danger">{this.state.errorMsg}</Alert>
            )
        }
        return (
            <Aux>
                <LoadingModal open={this.state.loading} msg="Loading..." />
                <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "0.5%" }}>
                    <Row form style={{ justifyContent: "flex-end" }}>
                        <Col md="auto">
                            <BackButton path="/retirementform" label="Go Back" />
                        </Col>
                    </Row>
                </div>
                {this.state.items}
            </Aux>
        )
    }

    // to call on view button click
    handleView = (transactionId, role) => {
        //window.location.href = `/viewform/${transactionId}/${role}`
        window.location.href = `/viewform/${transactionId}`
    }
    // to call on edit button click
    handleEdit = (transactionId) => {
        window.location.href = `/editexcesstoolform/${transactionId}`
    }
    // to call on delete button click
    handleDelete = async (transactionId, toolid) => {
        // eslint-disable-next-line no-restricted-globals
        const userSelection = confirm("Are you sure you want to delete this form? You will not be able to undo this action.");
        if (userSelection) {
            try {
                this.setState({ loading: true })
                const result = await postform.removeTransactionDetails(transactionId);
                //console.log("transactionId==>",result)
                if (result) {
                    const reqBody = {
                        level: "info",
                        message: "Transaction is deleted. Logged in User :" + this.props.user + " , transactionid : " + transactionId + " , toolid : " + toolid
                    }
                    axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                    );
                    setTimeout(() => {
                        this.setState({ loading: false })
                        window.location.reload(false)
                    }, 5000);
                }
            } catch (error) {
                console.log("error=>", error)
                const reqBody = {
                    level: "error",
                    message: "Error while deleting transaction. : toolid :" + toolid + " : error: " + JSON.stringify(error)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
                this.setState({
                    error: true,
                    loading: false,
                    errorMsg: errorConstants.unabletodelete
                })
            }
        }
    }
    // to get the transactions based on user role, Helper function to fetch recursively until all pages are collected 
    // Helper function to fetch ALL transactions using while loop

    async fetchAllTransactions(query) {
        let allItems = [];
        let nextToken = null;

        //read limit from .env (string converted to number  with parentInt) and
        // one fallback value added if the .evn is undefined .

        const limit = parseInt (process.env.REACT_APP_TRANSACTION_TABLE_LIMIT, 10);
        do {
            try {
                // call API with limit and nextToken
                const apiData = await API.graphql(
                    graphqlOperation(query, { limit, nextToken })
                );

                //  access schema field directly ( schema uses listExcesstransactions)
                const result = apiData.data.listExcesstransactionss;
                console.log("GraphQL REsult:", result);;

                if (result && result.items) {
                    allItems = [...allItems, ...result.items];
                    console.log("Fetched batch:", result.items.length);
                } else {
                    console.warn("No items returned in this batch:", result);
                }

                // update loop condition
                nextToken = result ? result.nextToken : null;

            } catch (error) {
                console.error("GraphQL fetch error:", error);
                break; // stop loop if error occurs
            }

        } while (nextToken);

        return allItems;
    }
    // to get the transactions based on user role

    async fetchTransactions(nextToken = null) {
        this.setState({ loading: true });



        //console.log(" transactions props.user =>",this.props.user);
        //console.log(" transactions context user, role=>",this.context.user,this.context.role);
        let role = this.context.role;
        // old approach without using appcontext
        // try {
        //     const q = `query 
        //     {
        //         listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}, filter: {id: {eq: "${this.props.user}" }}) {
        //             items {
        //                 role
        //             }
        //         }
        //     }`;
        //     const apiData =await API.graphql(graphqlOperation(q))
        //     const results = apiData.data.listExcessuserroless.items;            
        //     if(results.length!==0 ){
        //         role = results[0].role
        //         console.log("user role=>",role)
        //     }            
        // } catch (error) {
        //     const reqBody = {
        //         level:"error",
        //         message: "Error while fetching the user roles data in transaction component. error: "+JSON.stringify(error)
        //     }
        //     axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
        //     reqBody,
        //     { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
        //     );
        // }

        // forming the columns for react table
        const items = []
        const columns = []
        homeColumns.forEach(col => {
            if (col.toLowerCase() === "actions") {
                columns.push({
                    Header: col,
                    accessor: col,
                    filterable: false,
                })
            }
            else if (col.toLowerCase() === "transactionid" || col.toLowerCase() === "isinitiator") {
                columns.push({
                    Header: col,
                    accessor: col,
                    show: false
                })
            }
            else if (col.toLowerCase() === "approved") {
                columns.push({
                    Header: col,
                    accessor: col,
                    filterable: true,
                    Cell: e => {
                        if (e.value.trim().toLowerCase() === "no") {
                            return <span style={{ "color": "orange" }}><b>Waiting for Approval</b></span>
                        }
                        else if (e.value.trim().toLowerCase() === "approved") {
                            return <span style={{ "color": "green" }}><b>{e.value.trim().toUpperCase()}</b></span>
                        }
                        else if (e.value.trim().toLowerCase() === "rejected") {
                            return <span style={{ "color": "red" }}><b>{e.value.trim().toUpperCase()}</b></span>
                        }
                        else {
                            return <span style={{ "color": "blue" }}><b>{e.value.trim()}</b></span>
                        }
                    }
                })
            }
            else if (col.toLowerCase() === "date" || col.toLowerCase() === "toolavailabledate") {
                // to display month in description
                const month = [];
                month[0] = "Jan";
                month[1] = "Feb";
                month[2] = "Mar";
                month[3] = "Apr";
                month[4] = "May";
                month[5] = "Jun";
                month[6] = "Jul";
                month[7] = "Aug";
                month[8] = "Sep";
                month[9] = "Oct";
                month[10] = "Nov";
                month[11] = "Dec";
                let today
                columns.push({
                    Header: col,
                    accessor: col,
                    filterable: true,
                    //sortable: true,
                    //defaultSortDesc: false,                    
                    Cell: e => {
                        let dt = new Date(e.value);
                        const dd = String(dt.getDate()).padStart(2, '0');
                        const mm = month[dt.getMonth()]; //January is 0!
                        const yyyy = dt.getFullYear();
                        today = yyyy + '-' + mm + '-' + dd;
                        return <span>{today}</span>
                    }
                })
            }
            else {
                columns.push({
                    Header: col,
                    accessor: col,
                    filterable: true,
                })
            }
        })
        columns.forEach((item, index, arr) => {
            item.Header = homeColumnHeaders[index]
        })

        //let filter = null;
        let query = null;
        if (role === "" || role == null || role.indexOf("Tool Sales") !== -1) {
            //filter = { filter: {initiator: {eq: this.props.user} } }                            
            query = `query ListExcesstransactionss(
    $filter: ModelexcesstransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExcesstransactionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
      transactionid
                            transactiontype
                            toolid
                            date
                            approved
                            toolstatus
                            location
                            wafersize
                            initiator
                            reviewer
                            reviewerremarks
                            fabsection
                            toolavailabledate
      }
      nextToken
    }
  }
`;
        }
        else {
            //filter = { filter: {approved: {ne: "DRAFT"}, or: {initiator: {eq: this.props.user}, and: {approved: {eq: "DRAFT"}}}}}
            //filter = { filter: {transactionid: {ne: "null"}} }
            query = `query ListExcesstransactionss(
    $filter: ModelexcesstransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExcesstransactionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        transactionid
                            transactiontype
                            toolid
                            date
                            approved
                            toolstatus
                            location
                            wafersize
                            initiator
                            reviewer
                            reviewerremarks
                            fabsection
                            toolavailabledate
      }
      nextToken
    }
  }
`;

        }

        try {
            //console.log("q=>",query)
            //const apiData = await API.graphql(graphqlOperation(listExcesstransactionss, filter));
            {/* const apiData = await API.graphql(graphqlOperation(query));
            //const apiData =await API.graphql(graphqlOperation(query))
            console.log("api data =>",apiData.data.listExcesstransactionss.items.length)
            const filteredResult = apiData.data.listExcesstransactionss.items.filter( (record)=> 
            {
                if(record.initiator !== this.props.user && record.approved==="DRAFT"){
                    return false
                }else{
                    return true
                }
            } )    */}
            //instead of this block we are  changing it with  call
            const allItems = await this.fetchAllTransactions(query);
            console.log("Total fetched items =>", allItems.length);

            const filteredResult = allItems.filter((record) => {
                if (record.initiator !== this.props.user && record.approved === "DRAFT") {
                    return false;
                }
                return true;
            });
            console.log("filteredResult  =>", filteredResult.length);
            this.setState(
                { results: filteredResult }
            )

        } catch (error) {
            console.error("Error while fetching transaction", error)

            console.log("error==>", JSON.stringify(error))
            const reqBody = {
                level: "error",
                message: "Error while fetching transaction data. error: " + JSON.stringify(error)
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({
                error: true,
                errorMsg: "Error while fetching transaction data"
            });

        }

        const data = this.state.results.map(e => {
            const rec = { ...e }
            Object.keys(rec).forEach(col => {
                if (!homeColumns.includes(col)) {
                    delete rec[col]
                }

            })
            rec.isInitiator = rec.initiator === this.props.user ? true : false;
            rec.Actions = this.buildActions(rec, role);
            return rec
        })
        items.push(
            <div key="reacttable">
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultSorted={[
                        {
                            id: "date",
                            desc: true
                        }
                    ]}
                    className="-highlight -striped"
                    defaultPageSize={20}
                />
            </div>
        )
        this.setState({
            loading: false,
            items
        })


    }

    // building action menu for each row
    buildActions = (transaction, role) => {
        let isReviewer = false;
        isReviewer = (role === "Admin" || role === "Reviewer") && true;
        const actions = [];
        actions.push(
            // <NavLink to={`/viewform/${transaction.transactionid}/${role}`} >
            <NavLink to={`/viewform/${transaction.transactionid}`} >
                <Button key={"view"} className={"action-buttons"} outline size="sm" color="info" alt="View form">
                    <MdVisibility />
                </Button>
            </NavLink>
        )
        if (transaction.isInitiator || isReviewer) {
            actions.push(
                <NavLink to={`/editexcesstoolform/${transaction.transactionid}`}>
                    <Button key={"edit"} className={"action-buttons"} outline size="sm" color="warning" alt="Edit form">
                        <MdEdit />
                    </Button>
                </NavLink>
            )
        } else {
            actions.push(<Button key={"edit"} disabled style={{ cursor: "no-drop" }} className={"action-buttons"} size="sm" ><MdEdit /></Button>)
        }
        const transactionStatus = transaction.approved.trim().toLowerCase();
        if (transaction.isInitiator && (transactionStatus === 'draft' || transactionStatus === 'rejected')) {
            actions.push(<Button key={"delete"} className={"action-buttons"} outline size="sm" color="danger" onClick={() => this.handleDelete(transaction.transactionid, transaction.toolid)} alt="Delete form"><MdDelete /></Button>)
        } else {
            actions.push(<Button key={"delete"} disabled style={{ cursor: "no-drop" }} className={"action-buttons"} size="sm" ><MdDelete /></Button>)
        }
        return <div key={"actions"} >{actions}</div>
    }
}